import moment from 'moment'

const reportDownloadOptions = [
  {
    value: moment(moment()).subtract(7, 'days').format('YYYY-MM-DD'),
    label: 'Last 1 Week',
  },
  {
    value: moment(moment()).subtract(31, 'days').format('YYYY-MM-DD'),
    label: 'Last 1 month',
  },
  {
    value: moment(moment()).subtract(92, 'days').format('YYYY-MM-DD'),
    label: 'Last 3 months',
  },
]

export { reportDownloadOptions }
